module.exports = __webpack_public_path__ + "img/default-profile-pic.11f4fe67.jpg";